import { useLocation, Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path: string;
}

const routeLabels: Record<string, string> = {
  '': 'Inicio',
  'dashboard': 'Dashboard',
  'operations': 'Operaciones',
  'new': 'Nueva Operación',
  'risk': 'Operaciones en Riesgo',
  'tasks': 'Tareas Operativas',
  'incidents': 'Incidencias',
  'documents': 'Documentos',
  'workflow': 'Estados y Flujo',
  'reports': 'Reportes',
  'crm': 'CRM',
  'contacts': 'Contactos',
  'opportunities': 'Oportunidades',
  'followups': 'Seguimientos',
  'statements': 'Estados de Cuenta',
  'contracts': 'Contratos y Condiciones',
  'client-incidents': 'Incidencias de Cliente',
  'portal': 'Portal Clientes',
  'invoices': 'Facturas',
  'payments': 'Pagos',
  'messages': 'Mensajes',
  'profile': 'Perfil',
  'support': 'Soporte',
  'erp': 'ERP Financiero',
  'users': 'Usuarios',
  'settings': 'Configuración',
  'audit': 'Auditoría',
  'integrations': 'Integraciones',
};

// Mapeo especial para rutas que necesitan contexto del padre
const contextLabels: Record<string, Record<string, string>> = {
  'operations': {
    'reports': 'Reportes Operativos',
  },
  'crm': {
    'reports': 'Reportes CRM',
  },
  'portal': {
    'operations': 'Mis Operaciones',
    'documents': 'Documentos',
    'statements': 'Estados de Cuenta',
    'invoices': 'Facturas',
    'payments': 'Pagos',
    'messages': 'Mensajes',
    'profile': 'Perfil',
    'support': 'Soporte',
  },
  'erp': {
    'reports': 'Reportes Financieros',
    'statements': 'Estados Financieros',
  },
};

export default function Breadcrumbs() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) {
    return null;
  }

  const breadcrumbs: BreadcrumbItem[] = [];
  let currentPath = '';

  pathSegments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    
    // Verificar si hay una etiqueta contextual
    let label = routeLabels[segment] || segment;
    
    if (index > 0) {
      const parentSegment = pathSegments[index - 1];
      if (contextLabels[parentSegment]?.[segment]) {
        label = contextLabels[parentSegment][segment];
      }
    }

    breadcrumbs.push({
      label,
      path: currentPath,
    });
  });

  return (
    <nav className="flex items-center gap-2 text-sm mb-6">
      <Link 
        to="/dashboard" 
        className="text-[#6B7280] hover:text-[#2F80ED] transition-colors cursor-pointer"
      >
        <i className="ri-home-4-line text-base"></i>
      </Link>
      
      {breadcrumbs.map((item, index) => (
        <div key={item.path} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-[#D1D5DB]"></i>
          {index === breadcrumbs.length - 1 ? (
            <span className="text-[#0A2A43] font-medium">{item.label}</span>
          ) : (
            <Link 
              to={item.path} 
              className="text-[#6B7280] hover:text-[#2F80ED] transition-colors cursor-pointer"
            >
              {item.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
}
